import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { css } from '@emotion/react';
import { useMemo } from 'react';

interface Props {
    value?: number;
    min?: number;
    max?: number;
    increase?: ()=> void;
    decrease?: ()=> void;
}

function MiniStepper({
    value, min, max, increase, decrease,
}:Props) {
    const decreaseEnabled = useMemo(() => {
        if (min !== undefined && value !== undefined) {
            return min < value;
        }
        return true;
    }, [min, value]);
    const increaseEnabled = useMemo(() => {
        if (max !== undefined && value !== undefined) {
            return value < max;
        }
        return value;
    }, [max, value]);
    return (
        <Row onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
        }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                onClick={() => {
                    if (decreaseEnabled) {
                        decrease?.();
                    }
                }}
            >
                <rect width="16" height="16" rx="8" fill={colors.gray3}/>
                <path d="M5 8L11 8" stroke={decreaseEnabled ? colors.gray7 : colors.gray5}
                    strokeWidth="2"
                    strokeLinecap="round"/>
            </svg>
            <Text as='span' align='center' color={colors.gray7} css={css`
                width: 40px;
            `}>
                {value}
            </Text>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                onClick={() => {
                    if (increaseEnabled) {
                        increase?.();
                    }
                }} >
                <rect width="16" height="16" rx="8" fill={colors.gray3}/>
                <path d="M5 8L11 8" stroke={increaseEnabled ? colors.gray7 : colors.gray5}
                    strokeWidth="2" strokeLinecap="round"/>
                <path d="M7.99512 4.99512L7.99512 10.9951" stroke={increaseEnabled ? colors.gray7 : colors.gray5}
                    strokeWidth="2" strokeLinecap="round"/>
            </svg>
        </Row>
    );
}

export default MiniStepper;
